import { useEffect } from 'react';

import { useStateIfMounted } from 'use-state-if-mounted';

import PropTypes from 'prop-types';

import { Image as HOMiiImage } from '../shared';

const ProgressiveImage = (props) => {

    const { thumbnailSrc, src, alt, ...rest } = props;

    const [currentImage, setCurrentImage] = useStateIfMounted(thumbnailSrc);

    const [loading, setLoading] = useStateIfMounted(true);

    useEffect(() => {
        fetchImage(currentImage);
    }, []);

    const fetchImage = async () => {

        const image = new Image();

        image.onload = () => {
            setCurrentImage(src);
            setTimeout(() => {
                setLoading(false);
            }, 700);
        };

        image.src = src;

    };

    const renderSingleImage = () => {
        if (!currentImage)
        return <>
            <img speed="0.95" width="100%" height="262" className='no-image' />
        </>;
        return <HOMiiImage className={ loading ? 'progressive-image-loading' : '' } isOldImage src={currentImage} alt={alt} {...rest} />;
    };

    return (
        <>
            <div className='progressive-image-blur-container'>
                {renderSingleImage()}
            </div>
        </>        
    );
     
};

export default ProgressiveImage;

ProgressiveImage.propTypes = {
    src: PropTypes.string,
    alt: PropTypes.string,
    thumbnailSrc: PropTypes.string,
};

